import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import MenuItem from "material-ui/MenuItem";
import SelectField from "material-ui/SelectField";

import previewSelectorMapStateToProps from "mapToProps/previewSelector";
import * as actions from "actions/userPreferences";

export class PreviewSelector extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event, index, value) {
    this.props.handleChange(value);
  }

  render() {
    // Mount-Point Props
    const { value } = this.props;

    // Map State Props
    const { previewOptions, defaultPreview } = this.props;

    return (
      <SelectField
        className="header-select preview-size"
        value={value || defaultPreview}
        onChange={this.handleChange}
      >
        {previewOptions.map(option => (
          <MenuItem
            key={option.value}
            value={option.value}
            primaryText={option.label}
          />
        ))}
      </SelectField>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return previewSelectorMapStateToProps(state, ownProps);
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  const { userPreferencesSelector } = ownProps;

  return Object.assign({}, stateProps, {
    handleChange: value =>
      dispatchProps.dispatchUserPreferenceChange(
        userPreferencesSelector,
        "preview",
        value
      )
  });
}

export default withRouter(
  connect(mapStateToProps, actions, mergeProps)(PreviewSelector)
);
